import React from "react";
import Link from "@amzn/meridian/link";
import { useNavigate } from "react-router";
import { scrollToElement } from "src/components/shared/utils/utils";

const KnowMoreLink = () => {
  const navigate = useNavigate();
  return (
    <Link
      onClick={() => scrollToElement("hoem_faq")}
    >
      {"Know more"}
    </Link>
  );
};

export default KnowMoreLink;
